import React, { useEffect } from 'react';

/**
 * Componente que aplica correções globais para tooltips
 * 
 * Este componente injeta estilos CSS necessários para garantir que tooltips
 * sejam exibidas corretamente na tela, mesmo quando estão dentro de Cards
 * ou outros componentes com overflow.
 */
const TooltipFixProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  useEffect(() => {
    // Criar um elemento de estilo
    const styleElement = document.createElement('style');
    styleElement.id = 'tooltip-fix-styles';
    
    // Adicionar regras CSS para corrigir tooltips
    styleElement.innerHTML = `
      /* Garantir que Cards e CardContent permitam overflow visível */
      .MuiCard-root {
        overflow: visible !important;
      }
      
      .MuiCardContent-root {
        overflow: visible !important;
      }
      
      /* Garantir que tooltips do Nivo estejam sempre visíveis */
      [role="tooltip"] {
        z-index: 9999 !important;
        pointer-events: none !important;
      }
      
      /* Correção para tooltips em gráficos */
      svg {
        overflow: visible !important;
      }
    `;
    
    // Adicionar o elemento de estilo ao head
    document.head.appendChild(styleElement);
    
    // Limpar ao desmontar o componente
    return () => {
      const existingStyle = document.getElementById('tooltip-fix-styles');
      if (existingStyle) {
        document.head.removeChild(existingStyle);
      }
    };
  }, []);
  
  return <>{children}</>;
};

export default TooltipFixProvider;
